import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import app from "./modules/app";
import permission from "./modules/permission";
import settings from "./modules/settings";
import user from "./modules/user";

Vue.use(Vuex);
const store = new Vuex.Store({
  modules: {
    app,
    permission,
    settings,
    user,
  },
  getters,
  state: {
    //测试服务器地址
    baseURL:process.env.VUE_APP_BASE_URL,
    ossUpload:process.env.VUE_APP_BASE_URL+"/common/admin_local_upload",
    mainParkId:1
  }
});

export default store;
